<template>
  <div class="achievement_wrap">
    <div v-if="active=='first'">
      无法查看
    </div>
    <student v-if="active=='second'"></student>
    <teacher v-if="active=='thrid'"></teacher>
  </div>
</template>
<script>
import student from './student/index'
import teacher from './teacher/index'
export default {
  components: { student, teacher },
  data() {
    return {  
      userType: sessionStorage.getItem('userType'), //这里本是localStorage
      active: 'first'
    }
  },
  mounted() {
    if(this.userType==0||this.userType==1){//这里本是0 1 
      this.active = 'thrid'
    }else{
      this.active = 'second'
    }
  },
  methods: {
    
  },
}
</script>
<style lang="scss">
  .achievement_wrap{
    width: 100%;
    height: 100%;
    padding: 16px;
    overflow-y: auto;
    box-sizing: border-box;
  }
</style>


// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/achievement/index.vue